import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";
import Vuex from "vuex";
import axios from "axios";
import store from "./store/";
import routes from "./routes/";
import "./filters/Filters.js";
import VueI18n from "vue-i18n";
import translate from "./translate/";
import styles from "./assets/css/styles.scss";
// import animate from "./assets/css/animate.scss";
import Helpers from "@/helpers/";
import CheckBox from "@/components/Inputs/Checkbox.vue";
import fgInput from "./components/Inputs/formGroupInput.vue";
import "@/helpers/google-analytics.js";
import ClickOutside from './directives/v-click-outside';

// import {
//   Option,
//   Select,
//   Input,
//   InputNumber,
//   Dialog,
//   Button,
//   Dropdown,
//   DropdownItem,
//   DropdownMenu,
// } from "element-ui";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "sweetalert2/dist/sweetalert2.min.css";
// import "element-ui/lib/theme-chalk/index.css";

Vue.config.productionTip = false;

const router = new VueRouter({
  routes,
  mode: "history",
  // scrollBehavior (to) {
  //   if (to.hash) {
  //     return {
  //       selector: to.hash
  //       // , offset: { x: 0, y: 10 }
  //     }
  //   }
  // }
});

router.beforeEach((to, from, next) => {
  window.scrollTo({ top: 0, behavior: "smooth" });
  next();
});

window.$axios = axios;

// Remoto
window.$axios.defaults.baseURL = "https://cllflex.com/";
const clientSecret = "HdaV4UOTBqg2D1ZqGSyZDL01GeV2EMABDSxmF7Rp";

// Local
// const clientSecret = 'V8yZqUNMFAPmtRBGBd9HOdXy6npj66eg0vGiQ32i';
// window.$axios.defaults.baseURL = 'http://127.0.0.1/edsa-server/api2/default/';

window.$axios.defaults.headers.common[
  "Authorization"
] = `Bearer ${clientSecret}`;

Vue.use(styles);
// Vue.use(animate);
Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(VueI18n);
// Vue.component("ElOption", Option);
// Vue.component("ElSelect", Input);
// Vue.component("ElInputNumber", InputNumber);
// Vue.component("ElSelect", Select);
// Vue.component("ElDialog", Dialog);
// Vue.component("ElButton", Button);
// Vue.component("ElDropdown", Dropdown);
// Vue.component("ElDropdownItem", DropdownItem);
// Vue.component("ElDropdownMenu", DropdownMenu);
Vue.component("CheckBox", CheckBox);
Vue.component("fg-input", fgInput);

// if (process.env.NODE_ENV === 'production') {
// Vue.use(VueGtag, {
//   property: {
//     id: 'G-K0CNFQ11K0'
//   }
// }, router);
// }

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: "pt", // set locale
  messages: translate, // set locale messages
});

Vue.directive('click-outside', ClickOutside);

new Vue({
  render: (h) => h(App),
  router,
  store,
  i18n,
}).$mount("#app");

Vue.prototype.$helpers = Helpers;
// Vue.prototype.$gtag = Vue.$gtag;
